/**
 * Resolve which Monday user id a worklog will be attributed to when opening
 * the LogWorkDialog from another user's row.
 *
 * - When `logForSelf` is true, the admin switched the dialog back to their
 *   own name → always use `currentUserId`.
 * - Otherwise, prefer the explicitly provided `forUserId` (on-behalf mode),
 *   falling back to `currentUserId` when none was provided.
 */
export function resolveEffectiveUserId(
  forUserId: string | undefined,
  currentUserId: string,
  logForSelf: boolean,
): string {
  const effectiveForUserId = logForSelf ? undefined : forUserId;
  return effectiveForUserId ?? currentUserId;
}
